import { render, staticRenderFns } from "./GetADemoNew.vue?vue&type=template&id=d767f3fa"
import script from "./GetADemoNew.vue?vue&type=script&lang=js"
export * from "./GetADemoNew.vue?vue&type=script&lang=js"
import style0 from "./GetADemoNew.vue?vue&type=style&index=0&id=d767f3fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports